module.exports = __webpack_public_path__ + "static/media/grasping-slug.0ebd9bb6.svg";